module.exports = __webpack_public_path__ + "media/components/Users/RegistrationsV2/EmailConfirmationModal/success-3f41dfd72e3c4cc65241cd859e0c9b3f.svg";